<ag-grid-angular
  [theme]="theme"
  #agGrid
  [class]="getStyleClass()"
  [gridOptions]="gridOptions"
  [components]="components"
  [singleClickEdit]="true"
  (gridReady)="onGridReady($event)">
</ag-grid-angular>
@if (showSum) {
  <div class="table-footer">
    @for (column of columns; track column) {
      <rask-footer-column [column]="column" [rows]="data"></rask-footer-column>
    }
  </div>
}

